import React from "react";
import Hero from "../components/Hero";
import Content from "../components/Content";
import MoreContent from "../components/MoreContent";
import Banner from "../components/Banner";

function Homepage() {
  return (
    <>
      <Hero />
      <Content />
      <MoreContent />
      <Banner />
    </>
  );
}

export default Homepage;
